import { Card } from '@gogovan/entier-web-core/ext/mui/Card';
import { styled } from '@gogovan/entier-web-core/ext/mui/styles';
import { Icon } from '@gogovan/entier-web-core/ext/mui/Icon';
import { Collapse } from '@gogovan/entier-web-core/ext/mui/Collapse';
import { Divider } from '@gogovan/entier-web-core/ext/mui/Divider';
import TriangleSvg from '@/assets/triangle.svg';
import { StepLabel } from '@gogovan/entier-web-core/ext/mui/StepLabel';
import { StepContent } from '@gogovan/entier-web-core/ext/mui/StepContent';

const TrackingCard = styled(Card)`
  margin: 0 48px 16px;

  ${(props) => props.theme.breakpoints.down('sm')} {
    margin: 0 24px 16px;
  }
`;

const CardHeader = styled('div')`
  padding: 20px;
  display: flex;
  font-size: 14px;
  justify-content: space-between;
  align-items: center;
  cursor: ${(props) => (props.canClick ? 'pointer' : 'unset')};

  ${(props) => props.theme.breakpoints.down('xs')} {
    padding: 10px 20px 10px 10px;
  }
`;

const StatusIcon = styled(Icon)`
  font-size: 40px !important;
  width: 40px;
  color: ${(props) => props.color};
  margin-right: 20px;

  ${(props) => props.theme.breakpoints.down('xs')} {
    margin-right: 10px;
  }
`;

const TitleRow = styled('div')`
  display: flex;
  font-weight: 500;
  align-items: center;
  width: max-content;

  ${(props) => props.theme.breakpoints.down('sm')} {
    flex-direction: column;
    align-items: normal;
  }
`;

const GgxNumber = styled('div')`
  font-size: 24px;
  margin-right: 8px;

  ${(props) => props.theme.breakpoints.down('sm')} {
    font-size: 20px;
  }
`;

const OrderStatusType = styled('div')`
  font-size: 20px;
  color: ${(props) => props.color};

  ${(props) => props.theme.breakpoints.down('sm')} {
    font-size: 16px;
  }
`;

const ExpandIcon = styled(Icon)`
  font-size: 20px;
  transform: rotate(${(props) => (props.openDetail ? 180 : 0)}deg);
  transition: transform 150ms ease;
  opacity: 60%;
  margin-left: 22px;

  ${(props) => props.theme.breakpoints.down('sm')} {
    margin-left: 0;
  }
`;

const OrderStatusDesc = styled('div')`
  font-size: 14px;
  opacity: 60%;
  align-items: center;
  display: flex;
`;

const HeaderTime = styled('div')`
  font-size: 14px;
  opacity: 60%;
  align-items: center;
  display: flex;
  justify-content: flex-end;
  width: 100%;

  ${(props) => props.theme.breakpoints.down('sm')} {
    justify-content: unset;
  }
`;

const Row = styled('div')`
  display: flex;
  align-items: center;
  width: 100%;
`;

const ContentCollapse = styled(Collapse)`
  padding: 0 20px 20px 25px;

  ${(props) => props.theme.breakpoints.down('sm')} {
    padding: 0 20px 20px 15px;
  }
`;

const CustomDivider = styled(Divider)`
  margin: 0 -20px 5px;
`;

const MobileVerticle = styled('div')`
  display: flex;
  width: 100%;

  ${(props) => props.theme.breakpoints.down('sm')} {
    flex-direction: column;
    align-items: unset;
  }
`;

const ProgressIcon = styled(TriangleSvg)`
  width: 12px;
  height: auto;
`;

const CustomStepLabel = styled(StepLabel)`
  padding: 0;
  color: unset;
  margin: -5.5px 0;

  ${(props) => props.theme.breakpoints.down('sm')} {
    margin: -7px 0;
  }

  .MuiStepLabel-iconContainer {
    padding-left: 6px;
  }

  .MuiStepConnector-line {
    .MuiStepConnector-line {
      ${(props) => props.theme.breakpoints.down('sm')} {
        height: 50px;
        margin: -30px 0;
      }
    }
  }

  .MuiStepLabel-label.Mui-active {
    font-weight: unset;
  }

  .MuiStepLabel-labelContainer {
    margin-top: -15px;
    color: unset;
  }
`;

const CustomStepMobileContent = styled(StepContent)`
  padding-left: 14px;
  display: flex;
`;

export {
  TrackingCard,
  StatusIcon,
  CardHeader,
  GgxNumber,
  OrderStatusType,
  OrderStatusDesc,
  Row,
  TitleRow,
  ContentCollapse,
  CustomDivider,
  ExpandIcon,
  HeaderTime,
  MobileVerticle,
  ProgressIcon,
  CustomStepLabel,
  CustomStepMobileContent,
};
